<script>
  import TableArea from "./TableArea.svelte";
  import ChartArea from "./ChartArea.svelte";
  import ExtraTableArea from "./ExtraTableArea.svelte";
  import { derived, writable } from "svelte/store";

  export let GanttStore;

  const {
    LeftTableWidth,
    ExtraColumns
  } = GanttStore;


  let minWidthPerColumnInPx = 50;
  let minWidthPerColumnPerExpectedLength = 15; // for example, a column with expectedLength 10 should have a minimum width of 150px during initialization

  function handleDrag(e) {
    const newTableWidth = e.clientX;
    if (newTableWidth < 100 || window.innerWidth - newTableWidth < 300) return;
    GanttStore.LeftTableWidth.update((_) => newTableWidth);
  }

  function stopDrag(e) {
    window.removeEventListener("mousemove", handleDrag);
    window.removeEventListener("mouseup", stopDrag);
  }

  function startDrag(e) {
    window.addEventListener("mousemove", handleDrag);
    window.addEventListener("mouseup", stopDrag);
  }

  function handleDragExtraColumns(e) {
    if (draggingIdx == 0)
      changedColumnSize.set(e.clientX);
    else 
      changedColumnSize.set(e.clientX - $Widths.slice(0, draggingIdx).reduce((a, b) => a + b, 0));
  }

  function stopDragExtraColumns(e) {
    window.removeEventListener("mousemove", handleDragExtraColumns);
    window.removeEventListener("mouseup", stopDragExtraColumns);
  }

  function startDragExtraColumns(e) {
    draggingIdx = Number(e.target.id.replace("resizer_", ""));
    window.addEventListener("mousemove", handleDragExtraColumns);
    window.addEventListener("mouseup", stopDragExtraColumns);
  }

  let draggingIdx = -1;
  const  changedColumnSize = writable(0);


  const Widths = derived([ExtraColumns, LeftTableWidth, changedColumnSize], ([$ExtraColumns, $LeftTableWidth, $changedColumnSize]) => {
    const ec = $ExtraColumns.filter((column) => column.displayed);
    let widths = $Widths;

    if (!widths) {
      if (ec.length == 0) {
        if ($LeftTableWidth != 200) LeftTableWidth.set(200);
        return [200];
      }
      widths = new Array(ec.length + 1);
      widths[0] = 10;
      for (let i = 0; i < ec.length; i++) {
        widths[i + 1] = $ExtraColumns.filter((column) => column.displayed)[i].expectedLength;
      }
      widths.forEach((_, i) => {
        widths[i] = widths[i] * minWidthPerColumnPerExpectedLength;
      });
      LeftTableWidth.set(widths.reduce((prev,current)=>prev + current, 0));
      return widths;
    }

    if (widths.length > ec.length + 1) {
      widths = widths.slice(0, ec.length + 1);
    } else {
      widths = widths.concat(new Array(ec.length + 1 - widths.length).fill(1.5 * minWidthPerColumnInPx));
    }

    let sum = widths.reduce((prev,current)=>prev + current, 0);

    if (sum != $LeftTableWidth) {
      widths.forEach((w, i) => {
        widths[i] = w / sum * $LeftTableWidth;
      });
    }

    if (draggingIdx + 1 < widths.length && $changedColumnSize > 0)  {
      let diff = $changedColumnSize - widths[draggingIdx];
      if (diff > 0 && widths[draggingIdx + 1] - diff >= minWidthPerColumnInPx || 
          diff < 0 && $changedColumnSize >= minWidthPerColumnInPx) {
        widths[draggingIdx + 1] -= diff;
        widths[draggingIdx] = $changedColumnSize;
      }
    }

    return widths;
  });

</script>

<div id="gantt_chartcontainer">
  <div class="table-area" style="width: {$LeftTableWidth}px;">
    <TableArea {GanttStore} width={$Widths[0]} />
    {#each $ExtraColumns.filter(column => !!column.displayed) as ec, ecIndex}
      <div class="resizer" on:mousedown={startDragExtraColumns} id="resizer_{ecIndex}"/>
      <ExtraTableArea
        {GanttStore}
        bind:width={$Widths[ecIndex + 1]}
        column={ec}
      />
    {/each}
  </div>
  <div class="resizer" on:mousedown={startDrag} />
  <div class="chart-area">
    <ChartArea {GanttStore} />
  </div>
</div>

<style>
  div#gantt_chartcontainer {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: row;
    z-index: 60;
  }
  .table-area {
    height: 100%;
    background-color: white;
    border-right: 0px solid #888888;
    display: flex;
  }
  .chart-area {
    flex-grow: 1;
    height: 100%;
    background-color: white;
  }
  .resizer {
    width: 3px;
    cursor: ew-resize;
    background-color: #ccc;
    height: 100%;
  }
</style>
